import React, { useState } from 'react';

const SMSControl = ({ onSendSMS, activeConversation }) => {
  const [smsText, setSmsText] = useState('');
  const [fromNumber, setFromNumber] = useState('+1234567890');
  const [sending, setSending] = useState(false);
  const [lastSent, setLastSent] = useState(null);

  const handleSendSMS = async (e) => {
    e.preventDefault();
    
    if (!smsText.trim()) {
      alert('Please enter SMS text');
      return;
    }

    if (!activeConversation) {
      alert('Please create a conversation first');
      return;
    }

    setSending(true);
    try {
      await onSendSMS(smsText, fromNumber);
      setLastSent({ text: smsText, time: new Date() });
      setSmsText('');
    } catch (error) {
      console.error('Error sending SMS:', error);
    } finally {
      setSending(false);
    }
  };

  const quickMessages = [
    "Hello there!",
    "What's the weather like?",
    "Tell me a joke",
    "How are you doing?",
    "What can you help me with?"
  ];

  const handleQuickMessage = async (message) => {
    setSmsText(message);
    // Auto-send after short delay
    setTimeout(async () => {
      if (activeConversation) {
        setSending(true);
        try {
          await onSendSMS(message, fromNumber);
          setLastSent({ text: message, time: new Date() });
          setSmsText('');
        } catch (error) {
          console.error('Error sending quick message:', error);
        } finally {
          setSending(false);
        }
      }
    }, 100);
  };

  return (
    <div className="sms-control">
      <h3>📱 SMS Trigger Control</h3>
      
      <form onSubmit={handleSendSMS} className="sms-form">
        <div className="form-group">
          <label>From Number:</label>
          <input
            type="tel"
            value={fromNumber}
            onChange={(e) => setFromNumber(e.target.value)}
            placeholder="+1234567890"
            className="phone-input"
          />
        </div>

        <div className="form-group">
          <label>SMS Message:</label>
          <textarea
            value={smsText}
            onChange={(e) => setSmsText(e.target.value)}
            placeholder="Type your SMS message here..."
            rows="3"
            className="sms-textarea"
            maxLength={160}
          />
          <small>{smsText.length}/160 characters</small>
        </div>

        <button 
          type="submit" 
          disabled={sending || !activeConversation || !smsText.trim()}
          className="send-sms-btn"
        >
          {sending ? '📤 Sending...' : '📱 Send to Avatar'}
        </button>
      </form>

      <div className="quick-messages">
        <h4>⚡ Quick Messages</h4>
        <div className="quick-buttons">
          {quickMessages.map((message, index) => (
            <button
              key={index}
              onClick={() => handleQuickMessage(message)}
              disabled={sending || !activeConversation}
              className="quick-msg-btn"
            >
              {message}
            </button>
          ))}
        </div>
      </div>

      {lastSent && (
        <div className="last-sent">
          <h4>✅ Last Sent</h4>
          <p>"{lastSent.text}"</p>
          <small>{lastSent.time.toLocaleTimeString()}</small>
        </div>
      )}

      {!activeConversation && (
        <div className="no-conversation-warning">
          ⚠️ Create a conversation first to send SMS triggers
        </div>
      )}
    </div>
  );
};

export default SMSControl;